/**
 * Renders one or more JSON-LD graphs as inline `<script type="application/
 * ld+json">` tags, as part of the normal React tree (same pattern as apps/
 * site's FAQ/Course structured data) — NOT via a `document.head` side
 * effect. That means it mounts and unmounts with the route component itself,
 * so a graph can never leak onto another route after a client-side
 * navigation, and never duplicates on re-render.
 */
export function JsonLd({ data }: { data: object | object[] }) {
  const items = Array.isArray(data) ? data : [data];
  return (
    <>
      {items.map((item, i) => (
        // eslint-disable-next-line react/no-danger
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }} />
      ))}
    </>
  );
}
